// apps/share-web/src/ui/freshness-line.ts
//
// Строка под «Team library»: в каком состоянии офлайн-кэш прямо сейчас.
//
// Чистая по отношению к состоянию: на вход — готовый `FreshnessState`
// (offline/freshness.ts), на выход — узел. Ни часов, ни сети, ни запросов:
// решать, ЧТО показать, — не дело вьюхи, её дело показать решённое.
//
// `data-state` вместо класса по тексту: офлайн красится атрибутом, а не
// совпадением строки, иначе перевод менял бы внешний вид.

import { t } from './i18n.js';
import { formatFreshWhen } from './format-date.js';
import type { FreshnessState } from '../offline/freshness.js';

export function renderFreshnessLine(state: FreshnessState, locale: string, nowMs: number): HTMLElement {
  const el = document.createElement('p');
  el.dataset.role = 'freshness';
  el.className = 'lib-freshness';
  // polite, не assertive: строка меняется при каждом обновлении, и настойчивое
  // объявление перебивало бы чтение списка ровно тогда, когда человек в нём
  // ищет песню.
  el.setAttribute('aria-live', 'polite');

  switch (state.kind) {
    case 'unknown':
      el.hidden = true;
      return el;
    case 'syncing':
      el.dataset.state = 'syncing';
      el.textContent = t('library.freshSyncing');
      return el;
    case 'justNow':
      el.dataset.state = 'fresh';
      el.textContent = t('library.freshJustNow');
      return el;
    case 'at':
      el.dataset.state = 'fresh';
      el.textContent = t('library.freshAt', { when: formatFreshWhen(state.iso, locale, nowMs) });
      return el;
    case 'offlineAt':
      el.dataset.state = 'offline';
      el.textContent = t('library.freshOfflineAt', { when: formatFreshWhen(state.iso, locale, nowMs) });
      return el;
  }
}
